import React, { useRef, useEffect, useState } from 'react'
import Img from 'gatsby-image'
import PortableText from '@sanity/block-content-to-react'
import HomeLink from '../components/HomeLink'
import styled from 'styled-components'
import { Power3, gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ReactPlayer from 'react-player'
import SlideCounter from '../components/SlideCounter'
import * as Scroll from 'react-scroll'
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from 'react-scroll'
import { util } from 'prettier'

// const ProjectNav = styled.section`
//   min-height: 100vh;
//   width: 100vw;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   align-content: center;
//   margin-top: 100vh;
//   box-sizing: border-box;
// `

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const StudentNav = styled.nav`
  background: var(--black);
  color: var(--white);
  box-sizing: border-box;
  padding: 1em;
  min-height: 100vh;
  /* margin-top: 100vh; */
  height: 100vh;
  overflow-y: scroll;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  transition: transform 0.75s cubic-bezier(0.28, 0.76, 0.41, 1);
  transform:${({ nav }) => nav ? 'translateX(0%)' : 'translateX(-100%)'};
  width:100vw;

  &.active{
    /* styles for an active nav */
    transform: translateX(0%);
  }

  .nav-project {
    min-width: 25%;
    max-width: 100%;
  }
  .nav-project-title {
    border-bottom: 0.1em solid var(--white);
    padding-bottom: 0.02em;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5vw;
    list-style: none;
    align-items:center;
    padding:0 0 0 5vw;

    ${media.medium}{
      grid-template-columns: repeat(3, 1fr);
      padding:10vw;

    }

    ${media.large}{
      grid-template-columns: repeat(4, 1fr);
      
    }

    li {
      color: var(--white);

      .writing{
        font-size:var(--medium-text);
      }
      a {
        color: var(--white);
        display: block;
        width:100%;
        &:hover {
          cursor: pointer;
        }
        &:active {
          transform: scale(0.8);
        }
        img,
        .video-thumbnail,
        .inset-image {
          width: 100%;
          border-radius: 6px;
        }
      }
    }
  }
`

const CounterContainer = styled.div`
  /* background:red; */
  width:100vh;
  height:3em;
  text-align:center;
  position:fixed;
  z-index:200;
  font-size:var(--medium-text);
  bottom:-4.5em;
  /* left:--40vw; */
  transform-origin:0% 0%;
  /* transform:rotate(-90deg) translateY( calc(-100vw + 4em)); */
  transform:rotate(-90deg) ;

  ${media.medium}{

  }
`

const StaticCounter = styled.button`
  border: 0.1em solid ${({ nav }) => (nav ? 'var(--light)' : 'var(--black)')};
  color:  ${({ nav }) => (nav ? 'var(--light)' : 'var(--black)')};
  margin-top: 6px;
  font-family: var(--sans);
  background: var(--light);
  background: none;
  font-weight: 500;
  font-size: var(--medium-text);
  padding: 0.5em 1em;
  border-radius: 2em;
  outline: none;
  display:inline-block;
  /* position:fixed; */
  z-index:200;
  /* top:0; */
  /* left:0.5em; */
  
  transition: border 0.3s cubic-bezier(0.28, 0.76, 0.41, 1), transform 0.3s cubic-bezier(0.28, 0.76, 0.41, 1);
  :active {
    transform: scale(0.8);
  }

  ${media.medium}{
    margin-top:14px;
  }

`

const Slide = styled.section``

export default function Artwork ({ artwork, student }) {
  const [nav, showNav] = useState(false)
  const revealRefs = useRef([])
  revealRefs.current = []

  // a component that shows one image full bleed.
  function ArtworkFullBleed ({ title, slideType, fullBleed }) {
    return (
      <Slide nav={nav} onClick={() => showNav(!nav, console.log(nav))}>
        {/* <h3>ArtworkFullBleed - {slideType}</h3> */}
        <Img className="full-bleed_img" imgStyle={{ objectFit: 'contain' }} fluid={fullBleed.fluid} alt="" />
      </Slide>
    )
  }

  // a component that displays a video from Vimeo
  function ArtworkVideo ({ slideType, url }) {
    // This function calls the vimeo API to grab the thumbnail
    async function fetchUserData () {
      try {
        const result = await fetch(
          // https://vimeo.com/api/oembed.json?url=https://vimeo.com/193641463
          'https://vimeo.com/api/oembed.json?url=' + url,
          {
            method: 'GET'
          }
        )
        return await result.json()
      } catch (err) {
        console.log(err)
        return null
      }
    }

    // Set state with thumbnail data
    const [thumbnail, setThumbnail] = useState()
    useEffect(() => {
      fetchUserData().then(data => {
        data && setThumbnail(data.thumbnail_url)
      })
    }, [])
    // https://i.vimeocdn.com/video/605393384_640.webp
    return (
      <Slide
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
        className="video"
      >
        <img className="video-thumbnail" src={thumbnail}></img>
      </Slide>
    )
  }

  //  a component that shows 2 images side by side.
  function Artwork2x2 ({ slideType, image01, image02 }) {
    return (
      <div
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
        className="grid"
      >
        {/* <h3>Artwork2x2 - {slideType}</h3> */}
        <Img fluid={image01.fluid} alt="" />
        {/* <Img fluid={image02.fluid} alt="" /> */}
      </div>
    )
  }

  // a component that shows 4 images
  function Artwork4x4 ({ slideType, image01, image02, image03, image04 }) {
    return (
      <Slide
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
        className="grid"
      >
        <Img fluid={image01.fluid} alt="" />
        {/* <Img fluid={image02.fluid} alt="" />
      <Img fluid={image03.fluid} alt="" />
      <Img fluid={image04.fluid} alt="" /> */}
      </Slide>
    )
  }

  // a component that shows one image, smaller within the viewport
  function ArtworkInset ({ slideType, inset, nav }) {
    return (
      <Slide
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
        className="inset"
      >
        <Img className="inset-image" imgStyle={{ objectFit: 'contain', objectPosition: 'bottom left' }} fluid={inset.fluid} alt="" />
      </Slide>
    )
  }

  // Does not read for a "writing type" -- read comments in slack
  // a component that loads Rich Text
  function ArtworkWriting ({ slideType, text }) {
    return (
      <Slide
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
        className="writing writing-nav"
      >
        <div>{text[0].children[0].text.substring(0, 50)}...</div>
        {/* {text.map((singleText, index) => (
        <>
          {singleText.children.map((single, i) => (
            // Change character count here
            <div key={index}>{single.text.substring(0, 50)}...</div>
          ))}
        </>
      ))} */}
      </Slide>
    )
  }

  function CheckSlideType ({ slide, workTitle, nav }) {
    if (slide.__typename === 'SanityFullBleed') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <ArtworkFullBleed
            fullBleed={slide.asset}
            slideType={slide.__typename}
          ></ArtworkFullBleed>
        </Link>
      )
    } else if (slide.__typename === 'SanityWorkVideo') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <ArtworkVideo
            url={slide.url}
            slideType={slide.__typename}
          ></ArtworkVideo>
        </Link>
      )
    } else if (slide.__typename === 'SanityGrid2X2') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <Artwork2x2
            image01={slide.image_01.asset}
            image02={slide.image_02.asset}
            slideType={slide.__typename}
          ></Artwork2x2>
        </Link>
      )
    } else if (slide.__typename === 'SanityGrid4X4') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <Artwork4x4
            image01={slide.grid_image_01.asset}
            image02={slide.grid_image_02.asset}
            image03={slide.grid_image_03.asset}
            image04={slide.grid_image_04.asset}
            slideType={slide.__typename}
          ></Artwork4x4>
        </Link>
      )
    } else if (slide.__typename === 'SanityInsetImage') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <ArtworkInset
            nav={nav}
            key={slide.id}
            inset={slide.asset}
            slideType={slide.__typename}
          ></ArtworkInset>
        </Link>
      )
    } else if (slide.__typename === 'SanityWriting') {
      return (
        <Link
          to={slide._key}
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          <ArtworkWriting
            text={slide._rawRichText}
            slideType={slide.__typename}
          ></ArtworkWriting>
        </Link>
      )
    }
  }

  if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
    gsap.config({ nullTargetWarn: false })
  }

  let sideNav = useRef(null)

  useEffect(() => {
    gsap.from(sideNav, {
      scrollTrigger: {
        trigger: '.student-artwork',
        start: 'top 33%',
        end: '+=30%',
        scrub: true
      },
      x: '-20vw'
    })

    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })
  })

  return (
    <>
      {/* <SlideCounter artwork={artwork} currentArtwork={'1'} artworkLength={'1'} onClick={() => { console.log('clicking') }} /> */}

      <CounterContainer ref={el => { sideNav = el }} className="side-nav">
        <HomeLink />
        <StaticCounter className='rotate-counter' nav={nav} onClick={() => showNav(!nav, console.log(nav))}>
          {student.first_name} {student.last_name}
          {/* Works */}
        </StaticCounter>
      </CounterContainer>

      <StudentNav className="student-nav" nav={nav}>
        <ul>
          {artwork.map((work, index) => (
            <>
              {/* <p className="nav-project-title">{work.title}</p> */}

              {work.slides.map((slide, i) => (
                // need to check each slide._type and conditionally load the proper Artwork function above
                // either: ArtworkVideo, ArtworkWriting, ArtworkInset, ArtworkFullBleed, Artwork2x2 or Artwork4x4
                // slides should load in the order they appear in the CMS which is flexible.
                <li nav={nav} onClick={() => showNav(!nav, console.log(nav))}>
                  <CheckSlideType
                    workTitle={work.title}
                    nav={nav}
                    key={index}
                    slide={slide}
                  ></CheckSlideType>
                </li>
              ))}
            </>
          ))}
        </ul>
      </StudentNav>
    </>
  )
}
